import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./Pages/Home";
import MessageInner from "./Pages/MessageInner";
import Layout from "./utlis/Layout";
import EventInner from "./Pages/EventInner";
import NewsInner from "./Pages/NewsInner";
import ICSETopperX from "./Pages/results/ICSETopperX";
import TopperInnerX from "./Pages/results/ICSETopperX";
import ISCToppersXII from "./Pages/results/ISCToppersXII";
import GalleryInner from "./Pages/Gallery/GalleryInner";
import SubGallery from "./Pages/Gallery/SubGallery";
import VideoGallery from "./Pages/Gallery/VideoGallery";
import About from "./Pages/About";
import VisionMission from "./Pages/about_us/VisionMission";
import Moto from "./Pages/about_us/Moto";
import AdmissionandWithdrawal from "./Pages/Prospects/AdmissionandWithdrawal";
import Registration from "./Pages/Prospects/Registration";
import Infrastructure from "./Pages/about_us/Infrastructure";
import OurSchool from "./Pages/about_us/OurSchool";
import Administration from "./Pages/about_us/Administration";
import Curricular from "./Pages/Academics/Curricular";
import Attendance from "./Pages/Academics/Attendance";
import Curriculum from "./Pages/Academics/Curriculum";
import Exams from "./Pages/Academics/Exams";
import SchoolUniform from "./Pages/Academics/SchoolUniform";
import AcademicCal from "./Pages/Academics/AcademicCal";
import Booklist from "./Pages/Academics/Booklist";
import ConductandDiscipline from "./Pages/Prospects/ConductandDiscipline";
import Recommendationtotheparents from "./Pages/Prospects/Recommendationtotheparents";
import InstructiontotheStudents from "./Pages/Prospects/InstructiontotheStudents";
import SchoolFee from "./Pages/Prospects/SchoolFee";
import BusRules from "./Pages/Prospects/BusRules";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout></Layout>,

      children: [
        {
          index: true,
          element: <Home />,
        },

        {
          path: "/Eventinner",
          element: <EventInner></EventInner>,
        },
        {
          path: "/NewsInner",
          element: <NewsInner></NewsInner>,
        },
        {
          path: "/ISCEToppers",
          element: <ICSETopperX></ICSETopperX>,
        },
        {
          path: "/ISCToppers",
          element: <ISCToppersXII></ISCToppersXII>,
        },
        // {
        //   path: "/galleryinner",
        //   element: <GalleryInner></GalleryInner>,
        // },
        {
          path: "/subGallery/:_id",
          element: <SubGallery></SubGallery>,
        },
        {
          path: "/about",
          element: <About></About>,
        },
        {
          path: "/OurSchool",
          element: <OurSchool></OurSchool>,
        },
        {
          path: "/Administration",
          element: <Administration></Administration>,
        },

        {
          path: "/vision-mission",
          element: <VisionMission></VisionMission>,
        },

        {
          path: "/moto",
          element: <Moto></Moto>,
        },

        {
          path: "/curriculum",
          element: <Curriculum></Curriculum>,
        },

        {
          path: "/curricular",
          element: <Curricular></Curricular>,
        },

        {
          path: "/infrastructure",
          element: <Infrastructure></Infrastructure>,
        },

        {
          path: "/exams",
          element: <Exams></Exams>,
        },

        {
          path: "/school-uniform",
          element: <SchoolUniform></SchoolUniform>,
        },

        {
          path: "/attendance",
          element: <Attendance></Attendance>,
        },
        {
          path: "/AcademicCal",
          element: <AcademicCal></AcademicCal>,
        },
        {
          path: "/attendance",
          element: <Attendance></Attendance>,
        },
        {
          path: "/Booklist",
          element: <Booklist></Booklist>,
        },
        {
          path: "/Registration",
          element: <Registration></Registration>,
        },
        {
          path: "/AdmissionandWithdrawal",
          element: <AdmissionandWithdrawal></AdmissionandWithdrawal>,
        },
        {
          path: "/ConductandDiscipline",
          element: <ConductandDiscipline></ConductandDiscipline>,
        },

        {
          path: "/Recommendationtotheparents",
          element: <Recommendationtotheparents></Recommendationtotheparents>,
        },
        {
          path: "/InstructiontotheStudents",
          element: <InstructiontotheStudents></InstructiontotheStudents>,
        },

        {
          path: "/SchoolFee",
          element: <SchoolFee></SchoolFee>,
        },
        {
          path: "/BusRules",
          element: <BusRules></BusRules>,
        },
        {
          path: "/galleryinner",
          element: <GalleryInner></GalleryInner>,
        },
        {
          path: "/VideoGallery",
          element: <VideoGallery></VideoGallery>,
        },

        {
          path: "/MessageInner",
          element: <MessageInner></MessageInner>,
        },
      ],
    },
  ]);
  return (
    <>
      <RouterProvider router={router}></RouterProvider>
    </>
  );
}

export default App;
